var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h3',[_vm._v(_vm._s(_vm.group.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }